// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { MatSnackBar } from '@angular/material';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, ActivatedRoute } from '@angular/router';


/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {
	// intercept request and add token
	constructor(
		private router: Router, 
		private snackbar: MatSnackBar){
			
		}
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// tslint:disable-next-line:no-debugger
		// modify request
		// request = request.clone({
		// 	setHeaders: {
		// 		Authorization: `Bearer ${localStorage.getItem('accessToken')}`
		// 	}
		// });
		// console.log('----request----');
		
		if (request.body && request.body.method && (request.body.method.indexOf('connection:connect') != -1 )){
			request = request.clone({
				setHeaders: {
					'X-CSRF-Token': environment.tokencsrf
				}
			});	
		}
		else
		{
			request = request.clone({
				setHeaders: {
					'X-AUTH-TOKEN': environment.tokenauth
				}
			});	
		}
		if (request.method === 'POST' || request.method === 'PUT') {
			this.shiftDates(request.body);
		}
		// console.log('--- end of request---');

		return next.handle(request).pipe(
			tap(
				event => {
					 if (event instanceof HttpResponse) {
						// console.log('all looks good',event);
						// http response status code
						// console.log(event.status);
						 
						 if (event.status==200 && event.body!=undefined
						 && event.body.error!=undefined
						 && event.body.error.data!=undefined
						  && event.body.error.message!=undefined
						  ) {
						console.log("login redicteur 1",event);	  
						if (event.body.error.data=='Non authorisé token'
						&& event.body.error.message=='Internal error')	{
							 this.router.navigateByUrl('/auth/login');
						} 
						
					}
						 
					}
				},
				error => {
					// http response status code
					// console.log('----response----');
					// console.error('status code:');
					// tslint:disable-next-line:no-debugger
					console.error(error.status);
					console.error(error.message);
					if(request.body.method.indexOf('connection:send401') == -1)
						this.snackbar.open("Erreur de communication avec le serveur", "", {
							duration: 5000,
							panelClass: ["error-snackbar"]
						});
					// console.log('--- end of response---');
				}
			)
		);
	}
	shiftDates(body) {
		if (body === null || body === undefined) {
			return body;
		}
	
		if (typeof body !== 'object') {
			return body;
		}
	
		for (const key of Object.keys(body)) {
			const value = body[key];
			if (value instanceof Date) {
				body[key] = new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes()
					, value.getSeconds()));
			} else if (typeof value === 'object') {
				this.shiftDates(value);
			}
		}
	}
}